/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Input_DeviceInputs */



/**
* | output |
* | --- |
* | "Input Device" |
*
* @param {Options_Pedal_Input_DeviceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_input_device = /** @type {((inputs?: Options_Pedal_Input_DeviceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Input_DeviceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Périphérique d'entrée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingabegerät")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dispositivo di input")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Устройство ввода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dispositivo de entrada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入设备")
	if (locale === "ja") return /** @type {LocalizedString} */ ("入力デバイス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इनपुट डिवाइस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dispositivo de entrada")
	return /** @type {LocalizedString} */ ("Input Device")
});